<div fxFlex class="p-10" style="width: 100%; height: 100%; display: flex; flex-direction: column; flex-grow: 1; overflow: hidden">
    <mat-card appearance="outlined" style="padding: 20px; overflow: hidden; max-height: 100%; padding-top: 20px">
        <div style="display: flex; height: 100%; width: 100%; flex-direction: column">
            @if (hookHoistActive) {
                <mat-tab-group #tabGroup mat-stretch-tabs style="margin-bottom: 20px" (selectedIndexChange)="onTabChange($event)">
                    <mat-tab label="Aircraft"></mat-tab>
                    <mat-tab label="Accessories"></mat-tab>
                </mat-tab-group>
            }
            <div fxFlex fxLayout="row">
                <div style="margin-right: 10px; font-size: medium; font-weight: bold">{{ aircraft?.registrationMark }}:</div>
                <div style="margin-right: 10px; font-size: medium">Aircraft Current Total Hours: {{ totalHours || 0 }}</div>
                @if (showFlightNumber) {
                    <div style="margin-right: 10px; font-size: medium">Last Flight Number: {{ helicopterData?.flightNumber || 0 }}</div>
                }
                <div style="font-size: medium">Aircraft Current Total Cycles: {{ totalCycles || 0 }}</div>
            </div>
            @if (hookHoistActive) {
                <div style="display: flex; flex-direction: row">
                    @for (hook of helicopterHooks; track hook.id) {
                        <div style="display: flex; flex-direction: row">
                            <div style="margin-right: 10px; font-size: medium; font-weight: bold">{{ hook.serial }} (Hook):</div>
                            @if (hook.hours !== "0:00" && hook.hours !== null) {
                                <div style="margin-right: 10px; font-size: medium">Hours: {{ hook.hours }}</div>
                            }
                            @if (hook.cycles > 0 && hook.cycles !== null) {
                                <div style="margin-right: 20px; font-size: medium">Cycles: {{ hook.cycles }}</div>
                            }
                        </div>
                    }
                    @for (hoist of helicopterHoists; track hoist.id) {
                        <div style="display: flex; flex-direction: row">
                            <div style="margin-right: 10px; font-size: medium; font-weight: bold">{{ hoist.serial }} (Hoist):</div>
                            @if (hoist.hours !== "0:00" && hoist.hours !== null) {
                                <div style="margin-right: 10px; font-size: medium">Hours: {{ hoist.hours }}</div>
                            }
                            @if (hoist.cycles > 0 && hoist.cycles !== null) {
                                <div style="margin-right: 20px; font-size: medium">Cycles: {{ hoist.cycles }}</div>
                            }
                        </div>
                    }
                </div>
            }
            <div fxFlex>
                <div fxFlex fxLayout="row" fxFlexFill fxLayoutAlign="space-between center">
                    <div fxFlex fxLayoutGap="10px" style="margin-top: 20px; margin-bottom: 20px">
                        @if (isCamo) {
                            <button mat-raised-button color="primary" [disabled]="!canDelete" (click)="openUpdateShortItemDialog()">Edit item</button>
                        }
                        @if (isCamo) {
                            <button mat-raised-button color="primary" [disabled]="!canDelete" (click)="openDeleteShortItemDialog()">Delete item</button>
                        }
                        <mat-checkbox [(ngModel)]="showOpenItems" (change)="applyOpenItemsFilter()">Show only open inspections</mat-checkbox>
                    </div>
                    <div fxFlex="10" fxFlexFill fxLayoutAlign="center center">
                        <button mat-raised-button color="primary" [disabled]="data.length === 0" (click)="excel.save()">
                            <mat-icon>download</mat-icon>
                            Export
                        </button>
                    </div>
                    @if (!showHookHoist) {
                        <div fxFlex="20" fxLayout="column" fxFlexFill>
                            <mat-form-field fxFlex class="mr-10">
                                <mat-label>ATL Block Number</mat-label>
                                <mat-select name="htlBlockNumber" (selectionChange)="onHtlBlockNumberChange($event)" [(ngModel)]="startBlockNumber">
                                    @for (block of htlBlockNumberArray; track block) {
                                        <mat-option [value]="block.id"> Nr. {{ block.blockNumber }} </mat-option>
                                    }
                                </mat-select>
                            </mat-form-field>
                        </div>
                    }
                </div>
            </div>
            <div style="display: flex; overflow: auto; height: 100%">
                <kendo-grid
                    #grid="kendoGrid"
                    style="height: 100%; width: 100%"
                    [kendoGridBinding]="data"
                    [data]="gridView"
                    [filterable]="'menu'"
                    [sortable]="true"
                    [resizable]="true"
                    [pageSize]="state.take"
                    [pageable]="{
                        info: true,
                        type: 'numeric',
                        buttonCount: 8,
                        position: 'bottom',
                        previousNext: true,
                        pageSizes: pageSizes,
                    }"
                    [skip]="state.skip"
                    [scrollable]="'scrollable'"
                    (selectionChange)="onSelectionChange($event)"
                    (dataStateChange)="dataStateChange($event)"
                    (excelExport)="excelExportData($event)"
                    [selectable]="{ enabled: true, checkboxOnly: true, mode: 'single' }"
                >
                    <kendo-grid-checkbox-column
                        [width]="50"
                        [sticky]="true"
                        [style]="{
                            'text-align': 'center',
                            'text-overflow': 'clip',
                            'background-color': 'white',
                        }"
                    ></kendo-grid-checkbox-column>
                    @for (col of gridColumns; track col.field) {
                        @if (col.isGroup && !col.disabled) {
                            <kendo-grid-column-group title="{{ col.title | translate }}">
                                @for (subCol of col.cols; track subCol.field) {
                                    @if (!subCol.disabled) {
                                        <kendo-grid-column class="no-padding" field="{{ subCol.field }}" title="{{ subCol.title | translate }}" [width]="subCol.width">
                                            <ng-template kendoGridCellTemplate let-dataItem>
                                                @let data = dataItem | accessValue: subCol.field;
                                                @if (subCol.isBool) {
                                                    <div>
                                                        <span
                                                            class="whole-cell"
                                                            style="text-align: center"
                                                            [ngStyle]="getStyles(dataItem, subCol.field)"
                                                            [innerHTML]="data ? '✔️' : '❌'"
                                                        ></span>
                                                    </div>
                                                } @else {
                                                    <div>
                                                        <span class="whole-cell" [ngStyle]="getStyles(dataItem, subCol.field)" [innerHTML]="data"></span>
                                                    </div>
                                                }
                                            </ng-template>
                                            <ng-template kendoGridFilterMenuTemplate let-filter let-column="column" let-filterService="filterService">
                                                <kendo-grid-string-filter-menu [column]="column" [filter]="filter" [filterService]="filterService">
                                                    <kendo-filter-contains-operator></kendo-filter-contains-operator>
                                                    <kendo-filter-not-contains-operator></kendo-filter-not-contains-operator>
                                                    <kendo-filter-eq-operator></kendo-filter-eq-operator>
                                                    <kendo-filter-neq-operator></kendo-filter-neq-operator>
                                                    <kendo-filter-isnull-operator></kendo-filter-isnull-operator>
                                                    <kendo-filter-isnotnull-operator></kendo-filter-isnotnull-operator>
                                                </kendo-grid-string-filter-menu>
                                            </ng-template>
                                        </kendo-grid-column>
                                    }
                                }
                            </kendo-grid-column-group>
                        } @else if (!col.disabled) {
                            <kendo-grid-column
                                class="no-padding"
                                field="{{ col.field }}"
                                title="{{ col.title | translate }}"
                                [width]="col.width"
                                [sticky]="col.field === 'inspectionTypeName'"
                            >
                                <ng-template kendoGridCellTemplate let-dataItem>
                                    @let data = dataItem | accessValue: col.field;
                                    @if (col.isBool) {
                                        <span class="whole-cell" style="text-align: center" [ngStyle]="getStyles(dataItem, col.field)" [innerHTML]="data ? '✔️' : '❌'"></span>
                                    } @else {
                                        <span class="whole-cell" [ngStyle]="getStyles(dataItem, col.field)" [innerHTML]="data"></span>
                                    }
                                </ng-template>
                                <ng-template kendoGridFilterMenuTemplate let-filter let-column="column" let-filterService="filterService">
                                    <kendo-grid-string-filter-menu [column]="column" [filter]="filter" [filterService]="filterService">
                                        <kendo-filter-contains-operator></kendo-filter-contains-operator>
                                        <kendo-filter-not-contains-operator></kendo-filter-not-contains-operator>
                                        <kendo-filter-eq-operator></kendo-filter-eq-operator>
                                        <kendo-filter-neq-operator></kendo-filter-neq-operator>
                                        <kendo-filter-isnull-operator></kendo-filter-isnull-operator>
                                        <kendo-filter-isnotnull-operator></kendo-filter-isnotnull-operator>
                                    </kendo-grid-string-filter-menu>
                                </ng-template>
                            </kendo-grid-column>
                        }
                    }
                </kendo-grid>
                <kendo-excelexport #excel [fileName]="filename" [data]="data">
                    @for (col of gridColumns; track col.field) {
                        @if (col.isGroup && !col.disabled) {
                            <kendo-excelexport-column-group title="{{ col.title | translate }}">
                                @for (subCol of col.cols; track subCol.field) {
                                    @if (!subCol.disabled) {
                                        <kendo-excelexport-column
                                            field="{{ subCol.field }}"
                                            title="{{ subCol.title | translate }}"
                                            [width]="subCol.width"
                                        ></kendo-excelexport-column>
                                    }
                                }
                            </kendo-excelexport-column-group>
                        } @else if (!col.disabled) {
                            <kendo-excelexport-column field="{{ col.field }}" title="{{ col.title | translate }}" [width]="col.width"></kendo-excelexport-column>
                        }
                    }
                </kendo-excelexport>
            </div>
        </div>
    </mat-card>
</div>
